module.exports = __webpack_public_path__ + "img/solution-pc-2.5e09dfad.png";